import React from 'react'
import { Icon } from '@drifthq/tide-core'
import { OnboardingBillingPage } from '@drifthq/billing-components'

import './style.css'

const Billing = ({
  onSkip,
  plan = 'standard',
  coupon,
}) => {
  return (
    <div className="touchless-billing-container">
      <Icon className="touchless-billing-drift-logo" name="drift-logo-full"/>
      <OnboardingBillingPage
        planName={plan}
        couponCode={coupon}
        className="touchless-billing-wrapper-page"
        skipPage={onSkip}
      />
    </div>
  )
}

export default Billing



// WEBPACK FOOTER //
// ./src/layouts/Billing/component.js